// @ts-nocheck
/**
 * Lazy getter to access the root store-of-stores. Used by individual zustand
 * stores to call cross-cutting helpers (`success`, `failure`, `firebase`,
 * `clearToast`, `initAppState`, `resetAppState`) and to read sibling stores.
 *
 * The root is registered by stores/index.js after every zustand store has
 * been created, breaking the circular import dependency.
 */
let root = null;

export const setRoot = (r) => { root = r; };
const getRoot = () => root || {};
export default getRoot;
